import { createFileRoute } from '@tanstack/react-router';

import { ZoneEditPage } from '../modules/zones/ui/pages/ZoneEditPage';

export const Route = createFileRoute(
  '/_authenticated/dashboard/locations/$locationId/zones/$zoneId/edit',
)({
  component: ZoneEditPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Zones', 'Edit'],
  },
});
